import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
  title?: string;
}

const CheckmarkIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "currentColor",
  width = "100%",
  height = "100%",
  title = "Checkmark",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 12"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>{title}</title>
      <path
        fill={fill}
        clipRule="evenodd"
        d="M13.408 1.85844L5.46241 11.5801L0.59375 5.62314L2.14233 4.35748L5.46241 8.4197L11.8594 0.592773L13.408 1.85844Z"
      />
    </svg>
  );
};

export default CheckmarkIcon;
